import axios from "axios";
import { 
    AGENT_CONNECTED, 
    DISPOSITION_ENDPOINT, 
    ECE_CONNECTED, 
    ECE_CONNECT_ERROR, 
    ECE_GENERIC_ERROR, 
    SURVEY_SHOWN, 
    SURVEY_SUBMITTED, 
    TOKEN_ERROR, 
    TOKEN_INITIATED, 
    TOKEN_RECEIVED, 
    UUID_ERROR, 
    UUID_INITIATED, 
    UUID_RECEIVED 
} from "../actions/dispositionAction";

const initialState = {
    genericId: '',
    uuid: '',
    agentName: '',
    endpoint: ''
};

export default function (state = initialState, action) {
    switch (action.type) {
        case TOKEN_INITIATED:
            postState(
                {
                    meta01: action.payload,
                    code: '1001'
                },
                state.endpoint
            );
            return {
                ...state,
                genericId: action.payload
            };

        case TOKEN_RECEIVED:
            postState(
                {
                    meta01: state.genericId,
                    code: '1002'
                },
                state.endpoint
            );
            return state;

        case UUID_INITIATED:
            postState(
                {
                    meta01: state.genericId,
                    code: '1003'
                },
                state.endpoint
            );
            return state;

        case UUID_RECEIVED:
            postState(
                {
                    meta01: state.genericId,
                    code: '1004',
                    mapKey: action.payload
                },
                state.endpoint
            );
            return {
                ...state,
                uuid: action.payload
            };

        case ECE_CONNECTED:
            postState(
                {
                    meta01: state.genericId,
                    code: '1005',
                    mapKey: state.uuid
                },
                state.endpoint
            );
            return state;

        case AGENT_CONNECTED:
            postState(
                {
                    meta01: state.genericId,
                    code: '1006',
                    mapKey: state.uuid,
                    meta02: action.payload
                },
                state.endpoint
            );
            return {
                ...state,
                agentName: action.payload
            };

        case SURVEY_SHOWN:
            postState(
                {
                    meta01: state.genericId,
                    code: '1007',
                    mapKey: state.uuid,
                    meta02: state.agentName
                },
                state.endpoint
            );
            return state;
        
        case SURVEY_SUBMITTED:
            postState(
                {
                    meta01: state.genericId,
                    code: '1008',
                    mapKey: state.uuid,
                    meta02: state.agentName
                },
                state.endpoint
            );
            return state;

        case TOKEN_ERROR:
            postState(
                {
                    meta01: state.genericId,
                    code: '9001',
                    meta02: action.payload
                },
                state.endpoint
            );
            return state;

        case UUID_ERROR:
            postState(
                {
                    meta01: state.genericId,
                    code: '9002',
                    meta02: action.payload
                },
                state.endpoint
            );
            return state;

        case ECE_CONNECT_ERROR:
            postState(
                {
                    meta01: state.genericId,
                    code: '9003',
                },
                state.endpoint
            );
            return state;

        case ECE_GENERIC_ERROR:
            postState(
                {
                    meta01: state.genericId,
                    code: '9004'
                },
                state.endpoint
            );
            return state;

        case DISPOSITION_ENDPOINT: 
            return {
                ...state,
                endpoint: action.payload
            };
        
        default: 
            return state;
    }
}

const postState = async (body, url) => {
    console.log('post state', body);
    /** here need to call api using axios */
    try {
        if(url!=='') {
            const res = await axios.post(url, body);
            console.log('res: ', res.data);
        } else {
            // disposition disabled
        }
        
    }catch(error) {
        console.log('error: ', error);
    }
}

export const selectDisposition = state => state.dispositions;